import { render, staticRenderFns } from "./recipient-mobile.vue?vue&type=template&id=1fc72019"
import script from "./recipient-mobile.vue?vue&type=script&lang=js"
export * from "./recipient-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports